var _circle, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalliba(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "#1C74D0",
    fillOpacity: 0.17
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_829_2527)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 20.0001,
    r: 15.381,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_2527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2745 20.2974C23.5322 20.0398 23.5322 19.6221 23.2745 19.3645L22.1483 18.2382V15.8726C22.1483 15.5082 21.8529 15.2129 21.4886 15.2129C21.1242 15.2129 20.8289 15.5082 20.8289 15.8726V18.5115C20.8289 18.6865 20.8984 18.8543 21.0221 18.978L22.3415 20.2974C22.4703 20.4262 22.6392 20.4907 22.808 20.4907C22.9769 20.4907 23.1457 20.4262 23.2745 20.2974Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0255 15.5107L16.0925 14.5777C15.3208 13.8061 14.0652 13.8061 13.2936 14.5777L12.8259 15.0455C11.7455 16.1258 11.5459 17.7911 12.3404 19.0951C13.095 20.3334 14.3585 22.1736 16.0925 23.9076C17.8272 25.6422 19.6679 26.9059 20.9065 27.6606C22.2048 28.4516 23.8704 28.2587 24.9547 27.1743L25.4225 26.7066C26.1941 25.9349 26.1941 24.6793 25.4225 23.9076L24.4894 22.9747C24.0374 22.5226 23.0894 21.9109 21.8187 22.893C21.5432 23.1059 21.194 23.12 20.9497 22.9282C20.212 22.3488 19.5195 21.7366 18.8915 21.1087C18.2618 20.4789 17.6479 19.7843 17.0669 19.044C16.8761 18.8009 16.8873 18.4556 17.0948 18.1848C18.0782 16.9018 17.4734 15.9587 17.0255 15.5107ZM17.9585 22.0417C18.6236 22.7067 19.3558 23.3541 20.1348 23.9659C20.8513 24.5286 21.8755 24.5167 22.6256 23.937C23.0861 23.581 23.2927 23.6439 23.5565 23.9076L24.4894 24.8406C24.7467 25.0978 24.7467 25.5164 24.4895 25.7736L24.0217 26.2413C23.3734 26.8897 22.3746 27.01 21.593 26.5338C20.4158 25.8166 18.6679 24.617 17.0255 22.9747C15.3837 21.3329 14.1843 19.5854 13.4672 18.4085C12.9905 17.6261 13.1105 16.6268 13.7589 15.9784L14.2266 15.5107C14.3552 15.3821 14.5241 15.3178 14.6931 15.3178C14.862 15.3178 15.031 15.3821 15.1596 15.5107L16.0925 16.4437C16.316 16.6672 16.4437 16.8654 16.0476 17.3822C15.4768 18.127 15.4692 19.1453 16.029 19.8587C16.6424 20.6403 17.2916 21.3747 17.9585 22.0417Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4886 11.2549C19.7813 11.2549 18.1226 11.8595 16.8182 12.9573C16.5394 13.1919 16.5036 13.6081 16.7382 13.8869C16.9729 14.1657 17.389 14.2014 17.6678 13.9668C18.7347 13.0689 20.0917 12.5743 21.4886 12.5743C24.7626 12.5743 27.4261 15.2379 27.4261 18.5118C27.4261 19.909 26.9314 21.2661 26.0331 22.3332C25.7985 22.6119 25.8343 23.0281 26.113 23.2628C26.3936 23.4989 26.8094 23.4598 27.0426 23.1829C28.1408 21.8784 28.7456 20.2195 28.7456 18.5118C28.7456 16.5734 27.9907 14.751 26.62 13.3804C25.2494 12.0097 23.427 11.2549 21.4886 11.2549Z",
    fill: "#1C74D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_829_2527",
    x: 0.618896,
    y: 0.619141,
    width: 38.762,
    height: 38.7617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.454902 0 0 0 0 0.815686 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_829_2527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_829_2527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_2527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8889,
    height: 16.8889,
    fill: "white",
    transform: "translate(11.8567 11.2549)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalliba);
export default __webpack_public_path__ + "static/media/calliba.182d7430fa0f1555feb3e863e9350872.svg";
export { ForwardRef as ReactComponent };